import { useSelector } from 'hooks';

/**
 * Whether the childcare fields belong on screen for this tenant.
 *
 * <p>The childcare module alone, deliberately not also the automatic-rostering one. The type is
 * master data about the plan unit, and recording it is worth doing before anything consumes it —
 * requiring the rostering module would lock out exactly the organisation that wants its data in place
 * before that module is switched on.
 *
 * <p>One hook rather than the check inline, so the two screens that gate on it cannot drift apart.
 */
export const useHasChildcareAccess = (): boolean => {
  const { hasKidsPlan } = useSelector((state) => state.grants);

  return Boolean(hasKidsPlan);
};
